import { Box, Button } from "@mui/material";
import React from "react";
import RenderForm from "../../../Components/Esaedro/RenderForm/RenderForm";
import RenderFormNew from "../../../Components/Esaedro/RenderForm/RenderFormNew";
import { Form } from "../../../Models/SysConf/Form";
import { ResourceNames } from "../../../Utils/ResourceNames";
import { useSelector } from "react-redux";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { useQuery } from "react-query";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import { useObjEdit } from "./LinkedResources";
import notify from "devextreme/ui/notify";
import { object } from "yup";
import { RoutePath } from "../../../Utils/RoutePath";
import { useNavigate } from "react-router-dom";

type Props = {};

const LinkedResourcesEdit = (props: Props) => {
  // Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  //React Router Dom
  const { objEdit, setObjEdit } = useObjEdit();
  const navigate = useNavigate();

  // Chimate Api
  const {
    data: formResourcesViewsLinks,
    isLoading: isLoadingFormResourcesViewsLinks,
  } = useQuery(
    [
      "form",
      ResourceNames.ResourcesViewsLinks,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewsLinks}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: resourcesViewsLinks,
    isLoading: isLoadingResourcesViewsLinks,
    isError: isErrorResourcesViewsLinks,
    refetch: refetchResourcesViewsLinks,
    isRefetching: isRefetchingResourcesViewsLinks,
  } = useQuery(
    ["resourcesViewsLinks", objEdit?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsLinks}?RecordSelection=View_ID=${objEdit?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceViewLink: Form | undefined = React.useMemo(() => {
    if (formResourcesViewsLinks) {
      let tmpForm: Form = formResourcesViewsLinks;
      tmpForm.FormsGroups.forEach((fg) => {
        fg.FormsFields.forEach((ff) => {
          if (ff.FieldName === "View_ID") {
            ff.Is_Editable = false;
          }
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formResourcesViewsLinks]);

  // Chiamata per salvare una nuova risorsa collegata
  const saveNewResourceViewLink = () => {
    const service = new cubeApiClient();

    service
      .updateObject(
        objEdit,
        `api/sys/${ResourceNames.ResourcesViewsLinks}`,
        tokenApi
      )
      .then(
        (data) => {
          refetchResourcesViewsLinks();
          notify("Risorsa collegata salvata con successo", "success", 1000);
          navigate(
            `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/linked_resources`
          );
        },
        (error) => {
          refetchResourcesViewsLinks();
          notify(
            "Errore nel salvataggio della risorsa collegata",
            "error",
            1000
          );
        }
      );
  };

  // ! Inizio DOM
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          justifyContent: "space-around",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
          mb: 3,
        }}
      >
        <React.Fragment>
          <RenderFormNew
            showTitle={false}
            isNew={false}
            form={formResourceViewLink}
            myObj={objEdit}
            saveNewObject={(e) => setObjEdit(e)}
          />
        </React.Fragment>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
        }}
      >
        <Button
          variant="contained"
          color="error"
          className="me-2"
          onClick={() =>
            navigate(
              `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/linked_resources`
            )
          }
        >
          Annulla
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => saveNewResourceViewLink()}
        >
          Salva
        </Button>
      </Box>
    </>
  );
};

export default LinkedResourcesEdit;
